import nibMark from '@/images/logos/nib.svg';
import { cn } from '@/lib/utils';

/**
 * The nib, taken straight from the logo.
 *
 * This was previously a redrawn pictogram, on the argument that the traced
 * artwork muddies at small sizes. That argument loses to brand consistency: the
 * mark a reader meets at the end of a poem should be the same object as the one
 * on the masthead, not a lookalike. The cleaned logo is simple enough to hold at
 * the sizes used here (16–24px), which the redraw was solving for before the
 * curves were fixed.
 */
export function Nib({ className, title }: { className?: string; title?: string }) {
  // A labelled nib is content; an unlabelled one is decoration and is hidden
  // outright. Expressing that as a conditional attribute reads as neither.
  if (title) {
    return <img src={nibMark} alt={title} className={cn('inline-block', className)} />;
  }
  return <img src={nibMark} alt="" aria-hidden="true" className={cn('inline-block', className)} />;
}

/**
 * End-of-story mark.
 *
 * Newspapers close a story with a small ornament so the reader knows the column
 * has ended rather than continued elsewhere. Ours is the logo's own nib flanked
 * by rules — the two motifs the masthead is built from.
 */
export function EndMark({ className }: { className?: string }) {
  return (
    <div className={cn('flex items-center justify-center gap-3 py-2', className)} aria-hidden="true">
      <span className="h-px w-12 bg-border" />
      <Nib className="h-6 w-auto" />
      <span className="h-px w-12 bg-border" />
    </div>
  );
}
